import React, {useState} from "react";
import './App.css';
import Navbar from "./components/Navbar";

import ScrollToTop from "./utils/Navigation/ScrollToTop";
import Router from "./utils/Router";
import SetColorScheme from "./utils/Navigation/SetColorScheme";
import SocialMediaButtons from "./components/SocialMediaButtons";
import dadosProjetos from "./dadosProjetos.json";

function App() {
  const [page, setPage] = useState("home");

  let backgroundImg;

  if(page === "home" || page === "sobre"){
    backgroundImg = '/resources/imgs/background/Background_Purple.svg';
  }
  if(page === "portfolio"){
    backgroundImg = '/resources/imgs/background/Background_Red.svg';
  }
  if(page === "servicos"){
    backgroundImg = '/resources/imgs/background/Background_Green.svg';
  }
  if(page === "contato"){
    backgroundImg = '/resources/imgs/background/Background_Orange.svg';
  }

  const colorVariants = {
    "home": {
      "text": "text-[#422B86]",
      "border": "border-[#422B86]"
    },
    "portfolio": {
      "text": "text-[#BE3455]",
      "border": "border-[#BE3455]"
    },
    "servicos": {
      "text": "text-[#88B017]",
      "border": "border-[#88B017]"
    },
    "contato": {
      "text": "text-[#E36F4A]",
      "border": "border-[#E36F4A]"
    },
    "sobre": {
      "text": "text-[#422B86]",
      "border": "border-[#422B86]"
    },
  }

  const contactInfo = {
    "wpp": "https://wa.me/5531991668272",
    "ig": "https://www.instagram.com/jraposoarquiteta/",
    "mail": "mailto:jraposo.arq@gmail.com"
  }

  const projetos = [
    "B&G",
    "B.N",
    "D.R",
    "F.N",
    "F.T",
    "I.B",
    "L.G",
    "L&L",
    "P.G",
    "P&J",
    "S&M",
    "W.A",
  ]

  return (
      <div
          className="bg-cover bg-center bg-scroll"
          style={{ backgroundImage: `url(${backgroundImg})` }}
      >
        <Navbar page={page} click={setPage} colors={colorVariants[page]}/>
        <SocialMediaButtons page={page} contactInfo={contactInfo}/>
        <ScrollToTop/>
        <SetColorScheme setPage={setPage}/>
        <Router setPage={setPage} page={page} colorVariants={colorVariants} contactInfo={contactInfo} projetos={projetos} dadosProjetos={dadosProjetos}/>
      </div>
  );
}

export default App;